import React from 'react';
import {Badge} from '@ui/Badge';
import {FreeAccess} from '../../pages/Profile/types';
import styles from './FreeAccess.module.scss';

export const FreeAccessCard = ({access, current = false, compact = false}: {
    access?: FreeAccess; current?: boolean; compact?: boolean;
}) => {
    const remaining = Math.max(0, access?.remaining_views ?? 15);
    return <article className={`${styles.card} ${current && !compact ? styles.current : ''}`}>
        <div className={styles.heading}><h3>Free</h3>{current && !compact && <Badge>Текущий тариф</Badge>}</div>
        <p className={styles.description}>Пробный тариф для знакомства с платформой</p>
        <div className={styles.balance}>
            <span className={`${styles.check} ${!remaining ? styles.warning : ''}`} aria-hidden="true">{remaining ? '✓' : '!'}</span>
            <span>{compact ? remaining : 15} бесплатных просмотров{!compact && ` (осталось: ${remaining})`}</span>
        </div>
        {!compact && <div className={styles.meter} role="meter" aria-label="Осталось бесплатных просмотров" aria-valuemin={0} aria-valuemax={15} aria-valuenow={Math.min(15, remaining)}>
            {Array.from({length: 15}, (_, i) => <span key={i} className={i < remaining && !access?.has_ever_paid ? styles.available : ''}/>)}
        </div>}
    </article>;
};
